<template>
  <div class="big-stavka-wrapper breakdown-stavka">
    <div class="troskovnik-element-title">
      {{ $t("forms.cost_sheet.breakdown.table_title") }}
    </div>
    <div class="troskovnik-stavke-wrapper">
      <div class="fiksne-stavke-header">
        <div class="st bd1">{{ $t("forms.cost_sheet.breakdown.h1") }}</div>
        <div class="st bd2">{{ $t("forms.cost_sheet.breakdown.h2") }}</div>
        <div class="st bd3a">{{ $t("forms.cost_sheet.breakdown.h3") }}</div>
        <div class="st bd3b">{{ $t("forms.cost_sheet.breakdown.h4") }}</div>
        <div class="st bd4">{{ $t("forms.cost_sheet.breakdown.h5") }}</div>
        <div class="st bd5">{{ $t("forms.cost_sheet.breakdown.h6") }}</div>
        <div class="st bd6">{{ $t("forms.cost_sheet.breakdown.h7") }}</div>
      </div>
      <div class="stavke-wrapper breakdown-wrapper">
        <div class="stavke-row" v-for="(stavka, key) in stavke" :key="key">
          <div
            @click="editBreakdown(stavka.local_id)"
            :class="[
              'row-number',
              chosen_id == stavka.local_id ? 'active' : '',
            ]"
          >
            {{ stavka.local_id }}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 13 13"
            >
              <g>
                <g>
                  <path
                    fill="#7b7b8a"
                    d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                  ></path>
                </g>
              </g>
            </svg>
          </div>
          <div class="fiksna-stavka">
            <div class="breakdown-el stavka-datum bd1">
              <v-menu
                ref="menu1"
                v-model="stavka.date_picker_open"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <input
                    type="text"
                    placeholder="dd.mm.yyyy"
                    readonly
                    :value="getDate(stavka.date)"
                    v-bind="attrs"
                    @click="stavka.date_picker_open = true"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  locale="hr"
                  :first-day-of-week="1"
                  v-model="stavka.date"
                  no-title
                  @input="stavka.date_picker_open = false"
                ></v-date-picker>
              </v-menu>
              <!-- <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"><g><g><path fill="#3325ae" d="M27.632 5.472v18.951a3.238 3.238 0 0 1-3.238 3.23H3.238A3.238 3.238 0 0 1 0 24.423V5.472a3.238 3.238 0 0 1 3.238-3.23h1.295V.087h2.16V2.24H20.94V.088h2.159V2.24h1.295a3.238 3.238 0 0 1 3.238 3.23zm-2.159 4.738H2.16v14.213a1.08 1.08 0 0 0 1.08 1.077h21.155a1.08 1.08 0 0 0 1.08-1.077zm0-4.738a1.08 1.08 0 0 0-1.08-1.077H23.1V6.55h-2.16V4.395H6.693V6.55H4.533V4.395H3.238a1.08 1.08 0 0 0-1.08 1.077v2.584h23.315zM4.102 12.47H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm-17.27 4.307H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zM4.102 21.085H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318-4.307h2.158v2.153h-2.158z"/></g></g>
                            </svg> -->
            </div>
            <div class="breakdown-el breakdown-textarea bd2">
              {{
                service_types.find((s) => s.id == stavka.service_type_id)
                  .naziv +
                " - " +
                stavka.description
              }}
            </div>
            <div class="breakdown-el breakdown-textarea bd3a bolded">
              <div>
                <div>
                  {{
                    stavka.osobe.results_final
                      ? stavka.osobe.results_final.name
                      : ""
                  }}
                </div>

                <div class="normal" v-if="isMultipleVisible(stavka)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Surađuje +{{
                          stavka.multiple_odvjetnik.results_final.length
                        }}
                      </div>
                    </template>
                    <div>
                      <p
                        v-for="(so, key) in stavka.multiple_odvjetnik
                          .results_final"
                        :key="key"
                      >
                        {{ so.name }}
                      </p>
                    </div>
                  </v-tooltip>
                </div>
              </div>
            </div>

            <input
              class="breakdown-el stavka-iznos bd3b bolded"
              disabled
              height="43px"
              :value="stavka.belonging_satnica_id"
            />
            <input
              type="text"
              class="breakdown-el stavka-iznos bd4"
              v-model="stavka.satnica"
              @input="calculateIznos(stavka)"
              oninput="this.value = this.value.replace(',','.').replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
            />
            <div class="breakdown-time-wrapper bd5 breakdown-el stavka-iznos">
              <div class="time-wrapper">
                <input
                  type="number"
                  min="0"
                  v-model="stavka.time_h"
                  @input="calculateIznos(stavka)"
                />
                <span> h</span>
              </div>
              <div class="time-wrapper">
                <input
                  type="number"
                  min="0"
                  max="59"
                  v-model="stavka.time_min"
                  @input="calculateIznos(stavka)"
                />
                <span> min</span>
              </div>
            </div>
            <input
              type="text"
              disabled
              class="breakdown-el stavka-iznos bd6"
              v-model="stavka.iznos"
            />
          </div>
          <div
            class="add-napomena add-button remove-item"
            @click="deleteStavka(stavka)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              <g>
                <g>
                  <path
                    fill="#70707E"
                    d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
      <div class="add-new" @click="addNew">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xmlns:avocode="https://avocode.com/"
          id="SVGDoc"
          width="12"
          height="12"
          version="1.1"
          viewBox="0 0 12 12"
        >
          <defs />
          <desc>Generated with Avocode.</desc>
          <g>
            <g>
              <title>Shape 544</title>
              <path
                d="M10.88006,4.71948c-0.14734,-0.14586 -0.32628,-0.2183 -0.5368,-0.2183h-3.28338v0v-3.24824c0,-0.20795 -0.07367,-0.38519 -0.22101,-0.53089c-0.14722,-0.1457 -0.32604,-0.21863 -0.5368,-0.21863h-1.51527c-0.21052,0 -0.38934,0.07293 -0.53668,0.21863c-0.14734,0.1457 -0.22101,0.32294 -0.22101,0.53089v3.24824v0h-3.28338c-0.2104,0 -0.38934,0.07243 -0.53668,0.2183c-0.14746,0.14603 -0.22101,0.3226 -0.22101,0.53072v1.4992c0,0.20828 0.07355,0.38536 0.22101,0.53105c0.14734,0.1457 0.32628,0.21846 0.53668,0.21846h3.28326v0v3.2479c0,0.20812 0.07379,0.38536 0.22113,0.53105c0.14734,0.1457 0.32616,0.2183 0.53668,0.2183h1.51539c0.21064,0 0.38934,-0.0726 0.53668,-0.2183c0.14746,-0.1457 0.22113,-0.32294 0.22113,-0.53105v-3.2479v0h3.28326c0.21064,0 0.38958,-0.07277 0.5368,-0.21846c0.14734,-0.1457 0.22101,-0.32277 0.22101,-0.53105v-1.4992c0,-0.20812 -0.07367,-0.38502 -0.22101,-0.53072z"
                fill="#7b7b8a"
                fill-opacity="1"
              />
            </g>
          </g>
        </svg>
        <span>{{ $t("forms.cost_sheet.breakdown.add") }}</span>
      </div>
      <div class="subtotal-wrapper">
        <div class="subtotal-value">
          <span>{{ $t("forms.cost_sheet.breakdown.total_h") }}</span
          ><span>{{ getUkSatiMin }}</span>
        </div>
        <div class="subtotal-value">
          <span>{{ $t("forms.cost_sheet.breakdown.total") }}</span
          ><span
            >{{
              getValue
                .toFixed(2)
                .toString()
                .replaceAll(".", ",")
                .replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g, "$1.")
            }}
            EUR</span
          >
        </div>
        <!-- <div class="subtotal-value"><span>PDV 25%</span><span>{{(getVAT).toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} EUR</span></div>
                <div class="subtotal-value"><span>sveukupno</span><span>{{(getSUM).toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} EUR</span></div> -->
      </div>
    </div>
    <BreakdownPopup
      v-if="is_active_popup"
      @closeMe="closePopup"
      :is_edit="is_edit"
      :stavka="this.stavke[current_stavka]"
      :service_types="service_types"
      :team_members="team_members"
      :edit_team_members="edit_team_members"
      :drop_items="final_satnica_list.map((s) => ({ id: s.id, naziv: s.id }))"
    />
  </div>
</template>

<script>
import moment from "moment";
import BreakdownPopup from "@/components/costSheetComponents/breakdown/BreakdownPopup.vue";
import $ from "jquery";

export default {
  components: { BreakdownPopup },
  props: ["stavke", "final_satnica_list", "team_members", "service_types"],
  data() {
    return {
      is_active_popup: false,
      current_stavka: 0,
      edit_team_members: [],
      is_edit: false,
      chosen_id: null,
    };
  },
  methods: {
    isMultipleVisible(single_stavka) {
        if(single_stavka.multiple_odvjetnik)
        {
            return single_stavka.multiple_odvjetnik.results_final.length > 0 
        }else{
            return false
        }
    },
    addNew() {
      this.is_edit = false;
      const new_id =
        this.stavke.length > 0
          ? Math.max(...this.stavke.map((s) => s.local_id)) + 1
          : 1;
      this.stavke.push({
        local_id: new_id,
        service_type_id: this.service_types[0].id,
        belonging_satnica_id: this.final_satnica_list[0].id,
        date_picker_open: false,
        date: moment(new Date(Date.now())).format("YYYY-MM-DD"),
        description: "",
        osobe: { results_final: { name: "", uid: "" } },
        multi_person: { results_final: { name: "", uid: "" } },
        satnica: 0,
        time_h: 0,
        time_min: 0,
        iznos: 0,
        vat_iznos: 0,
      });
      this.current_stavka = this.stavke.length - 1;
      this.is_active_popup = true;
      this.chosen_id = new_id;
      this.$emit("refreshListeners");
    },
    editBreakdown(id) {
      this.is_edit = true;
      this.current_stavka = this.stavke.findIndex((i) => i.local_id == id);
      this.edit_team_members = this.stavke[this.current_stavka].osobe
        .results_final
        ? this.stavke[this.current_stavka].osobe.results_final
        : [];
      this.is_active_popup = true;
      this.chosen_id = id;
    },
    closePopup() {
      this.is_active_popup = false;
      this.chosen_id = null;
      this.stavke = this.stavke.sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
    },
    deleteStavka(delete_this) {
      let updated_stavke = this.stavke.filter((st) => st != delete_this);
      this.$emit("update:stavke", updated_stavke);
      this.$emit("refreshListeners");
    },
    calculateIznos(stavka) {
      const h = stavka.time_h != "" ? stavka.time_h : 0;
      const min = stavka.time_min != "" ? stavka.time_min / 60 : 0;
      stavka.iznos = h * stavka.satnica + min * stavka.satnica;
      stavka.iznos = stavka.iznos.toFixed(2);
    },
    calculateVAT(stavka) {
      stavka.vat_iznos = stavka.iznos * 0.25;
    },
    getDate(date) {
      return moment(date).format("DD.MM.YYYY.");
    },
  },
  model: {
    prop: "stavke",
    event: "click",
  },
  computed: {
    getValue() {
      return this.stavke != undefined
        ? this.stavke.reduce(function (prev, next) {
            return prev + Number(next.iznos);
          }, 0)
        : 0;
    },
    getVAT() {
      return this.stavke != undefined
        ? this.stavke.reduce(function (prev, next) {
            return prev + Number(next.vat_iznos);
          }, 0)
        : 0;
    },
    getSUM() {
      return this.stavke != undefined
        ? this.stavke.reduce(function (prev, next) {
            return prev + Number(next.iznos) + Number(next.vat_iznos);
          }, 0)
        : 0;
    },
    getUkSatiMin() {
      let uk_sati =
        this.stavke != undefined
          ? this.stavke.reduce(function (prev, next) {
              return prev + Number(next.time_h);
            }, 0)
          : 0;
      let uk_min =
        this.stavke != undefined
          ? this.stavke.reduce(function (prev, next) {
              return prev + Number(next.time_min);
            }, 0)
          : 0;
      if (uk_min >= 60) {
        const new_sati = parseInt(uk_min / 60);
        uk_sati += new_sati;
        uk_min = uk_min - new_sati * 60;
      }
      return `${uk_sati}h ${uk_min}min`;
    },
  },
};
</script>
